export default {
  // --- return-sale-meta.tsx ---
  Pending: "En attente",
  Approved: "Approuvé",
  Rejected: "Rejeté",
  Completed: "Terminé",
  "Order ID": "ID de la commande",
  "Customer Name": "Nom du client",
  Quantity: "Quantité",
  Amount: "Montant",
  Status: "Statut",
  Actions: "Actions",

  // --- return-sale-form.tsx ---
  "Customer First Name": "Prénom du client",
  "Customer Last Name": "Nom de famille du client",
  "Product Shop ID": "ID de la boutique du produit",
  "Shop ID": "ID de la boutique",
  "Payment Method": "Méthode de paiement",
  Reason: "Raison",
  Description: "Description",

  // --- select-return-sale.tsx ---
  "Return Sale": "Retour de vente",
  "Search return sale by order ID, customer name, reason, or description":
    "Rechercher un retour de vente par ID de commande, nom du client, raison ou description",
  "Edit Selection": "Modifier la sélection",
  "No return sales found": "Aucun retour de vente trouvé",

  // --- create-return-sale-modal.tsx ---
  "Create a new return sale": "Créer un nouveau retour de vente",

  // --- edit-return-sale-modal.tsx ---
  "Edit Return Sale": "Modifier le retour de vente",

  // --- view-return-sale-modal.tsx & view-return-sale-block.tsx ---
  "General Information": "Informations générales",

  // --- delete-return-sale-modal.tsx ---
  "Do you really want to delete this Return Sale?":
    "Voulez-vous vraiment supprimer ce retour de vente ?",
  "Warning: This action is irreversible and may lead to cascade deletions.":
    "Avertissement : Cette action est irréversible et peut entraîner des suppressions en cascade.",
  Cancel: "Annuler",
  "Confirm Deletion": "Confirmer la suppression",

  // --- return-sale-list-block.tsx ---
  "Add return sale": "Ajouter un retour de vente",

  // --- General ---
  Submit: "Soumettre",

  ID: "ID",
  "Created At": "Créé le",
  "Sale ID": "ID Vente",
  "Stock Batch ID": "ID Lot de stock",
  "Product ID": "ID Produit",
  "Product Name": "Nom du produit",
  Product: "Produit",
  product: "produit",
  quantity: "quantité",
  Refundable: "Remboursable",
  "Refunded Amount": "Montant remboursé",
  status: "statut",
  reason: "raison",
  actions: "actions",
  pending: "en attente",
  approved: "approuvé",
  rejected: "rejeté",
  completed: "terminé",
  "Set as pending": "Marquer comme en attente",
  "Set as approved": "Marquer comme approuvé",
  "Set as rejected": "Marquer comme rejeté",
  Price: "Prix",
  price: "prix",
  Qty: "Qté",
  qty: "qté",
  "Return Qty": "Qté retour",
  Refund: "Remboursement",
  refund: "remboursement",
  "Sale Returns Report": "Rapport des retours sur vente",
  "Quantity Ordered": "Quantité commandée",
  "The return quantity cannot be greater that ordered quantity":
    "La quantité de retour ne peut pas être supérieure à la quantité commandée",
  "Description / Observation": "Description / Observation",
  "Refundable amount": "Montant remboursable",
  "Amount to refund": "Montant à rembourser",
  "Save the changes": "Enregistrer les modifications",
  "Process a return": "Traiter un retour",
  Customer: "Client",
  customer: "client",
  "Net Amount": "Montant Net",
  Discount: "Remise",
  "Delivery Fee": "Frais de livraison",
  "Serve by": "Servi par",
  "Updated At": "Mis à jour le",
  "Total Refundable Amount": "Montant total remboursable",
  "Net Amount to refund": "Montant net à rembourser",
  "Process return": "Traiter le retour",
  "Sales returns": "Retours de ventes",
};
